<template>
  <div>
    <div class="BkHeight">
      <div class="BkHeight-W">
        <div class="Homeinput"><Homseach></Homseach></div>
        <!-- <Homseach @search="searchs"></Homseach> -->
        <div class="BkHeight_conent">
          <div class="BkHeight_conent_header">
            <p>
              <span>Block Height Detail</span>
            </p>
          </div>
          <div class="BkHeight_conent_Ul">
            <ul>
              <li v-for="(item, index) in list" :key="index">
                <p>{{ item.Block }}</p>
                <p ref="ele" class="notranslate">
                  {{ item.BlockHeight }}
                  <span v-if="index == 1">( {{ TimeDate }} )</span>
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div class="BlockDetails">
          <div class="Blocks">
            <div class="Block_Top">
              <span>Blcoks ({{ total }})</span>
              <span>
              
              </span>
            </div>
            <div v-show="list2.length > 0">
              <div class="Block_list">
                <ul class="block_list_Top">
                  <li>Block Hash</li>
                  <li>Packer</li>
                  <li>Age</li>
                  <li>Txn</li>
                  <li>Gas</li>
                </ul>
              </div>
              <div class="Block_List_center">
                <ul>
                  <li
                    v-for="(item, index) in list2"
                    :key="index"
                    class="notranslate"
                  >
                    <p @click="blockHash(item.blockHash)">
                      {{ getSubStr(item.blockHash) }}
                    </p>
                    <p @click="to2(item.packer)"><img :src="item.packerLogo"/>{{ item.packerName }}</p>
                    <p>
                      <span>
                        {{ item.blockTime }}
                        <!-- <span class="Hover1">
                          <span class="Hover"
                            >{{ TimeDate1[index]
                            }}<i class="iconfont">&#xe600;</i></span
                          >
                        </span> -->
                      </span>
                    </p>
                    <p>{{ item.tradeNums }}</p>
                    <p>{{ item.gas }}TTOS</p>
                  </li>
                </ul>
              </div>
              <div class="Block_List_Bottom">
                <el-pagination
                  class="notranslate"
                  :current-page.sync="PaginationIndex"
                  background
                  layout="prev, pager,
      next"
                  @current-change="CurrentChange"
                  :total="total"
                >
                </el-pagination>
              </div>
            </div>
            <div v-show="list2.length <= 0">
              <EmptyState />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Homseach from "@/components/pc/serch.vue";
import Homeinput from "../Home/Home_input";
import Pagination from "../BlockList/Pagination";
import Pagination2 from "../BlockList/Pagination2";
import EmptyState from "../EmptyState/EmptyState.vue";
import { GetheightDetail } from "@/assets/server/api";
import { timestampConvertTime, formatSeconds,getSubStr } from "@/utils/utils";
export default {
  data() {
    return {
      list: [
        {
          BlockHeight: "",
          Block: "Block Height：",
        },
        {
          BlockHeight: "20 secs ago",
          Block: "Age:",
        },
        {
          BlockHeight: "20 secs ago",
          Block: "Tx Count：",
        },
      ],
      time: "",
      list2: [],
      data: [],
      total: null,
      PaginationIndex: 1,
      Heigth: "",
      Tiaoshu: "",
      Page1: "",
      TimeDate: [],
      TimeDate1: [],
      imgurl1:require("@/assets/pc/Index/vers.png"),
      imgurl:require("@/assets/pc/Index/indexlogo.png")
    };
  },
  components: {
    Homeinput,
    Pagination,
    EmptyState,
    Pagination2,
    Homseach,
  },
  computed: {},
  created() {},
  mounted() {
    this.Heigth = this.$route.query.height;
    this.PaginationIndex = 1;
  },
  watch: {
    $route: {
      handler: function (to) {
        this.Heigth = to.query.height;
        this.PaginationIndex = 1;
        this.heightDetail();
      },
      deep: true,
      immediate: true,
    },
  },
  destroyed() {},
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  methods: {
    async heightDetail() {
      const params = {
        height: this.Heigth,
        pageNum: this.PaginationIndex,
        pageSize: 10,
      };
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      await GetheightDetail(formData).then((res) => {
       // console.log(res);
        this.list[0].BlockHeight = res.result.blockHeight;
       // console.log(this.list[0].BlockHeight);
        this.list[2].BlockHeight = res.result.txCount + " Txns";
        this.total = res.result.blockCount;
        let UTCTime = res.result.linuxTime - this.getClientTimezone * 3600000;
        this.TimeDate = timestampConvertTime(UTCTime);
        for (let i = 0; i < res.result.blockList.length; i++) {
          let UTCTime1 =
            res.result.blockList[i].blockTime -
            this.getClientTimezone * 3600000;
          this.TimeDate1[i] = timestampConvertTime(UTCTime1);
        }
        var calctime = new Date();
        let strdate = Math.floor(calctime.getTime() / 1000);
        let timestamp = Math.floor(this.gltime(res.result.blockTime) / 1000);
        var s = strdate - timestamp;
        if (s <= 0) {
          s = 1;
        }
       // res.result.time = formatSeconds(s);
        this.list[1].BlockHeight = formatSeconds(s);
        this.list2 = res.result.blockList;
      //  console.log(this.list2);
        this.TransactionsList2();
      });
    },
    TransactionsList2() {
      var calctime = new Date();
      let strdate = Math.floor(calctime.getTime() / 1000);
      for (let i = 0; i < this.list2.length; i++) {
        let timestamp = Math.floor(this.gltime(this.list2[i].blockTime) / 1000);
        var s = strdate - timestamp;
        if (s <= 0) {
          s = 1;
        }
        if(this.list2[i].packerName==""){
          this.list2[i].packerName=getSubStr(this.list2[i].packer,0,6);
        }
        if(this.list2[i].packerLogo==""){
          this.list2[i].packerLogo=this.imgurl1;
        }
        this.list2[i].blockTime = formatSeconds(s);
      }
    },
    to2(item) {
      this.$router.push({
        path: "/pc/BkHash",
        query: { query: item },
      });
    },
    gltime(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },
    getSubStr(str) {
      var subStr1 = str.substr(0, 5);
      var subStr2 = str.substr(str.length - 5, 5);
      var subStr = subStr1 + "..." + subStr2;
      return subStr;
    },
    CurrentChange(e) {
      this.PaginationIndex = e;
      this.Page1 = this.getContextData("tiaozhuan") || 1;
      this.heightDetail();
    },
    blockHash(index) {
      sessionStorage.removeItem("tiaozhuan");
      this.$router.push({ path: "/pc/BkDetail", query: { blockHash: index } });
    },
    searchs(e) {
      this.Heigth = e.blockHeight;
    },
    tiaozhuan1(e) {
      this.PaginationIndex = e;
      this.TransactionsList();
    },
    getContextData: function (key) {
      const str = sessionStorage.getItem(key);
      if (typeof str == "string") {
        try {
          return JSON.parse(str);
        } catch (e) {
          return str;
        }
      }
      return;
    },
  },
};
</script>
<style lang="less" scoped>
@import url("https://at.alicdn.com/t/font_3404326_3s5grzrpcqy.css");
.BkHeight {
  width: 100%;
  height: 100%;
  background: #13161b;
  .BkHeight-W {
    width: 1160px;
    margin: 0 auto;

    .Homeinput {
      padding: 40px 0;
    }
    .BkHeight_conent {
      border: 1px solid #0b0c0f;
      background: #0b0c0f;
      border-radius: 16px 16px 16px 16px;
      // padding: 20px 20px 0 20px;
      margin-bottom: 20px;
      width: 1160px;
      height: 240px;
      background: #0b0c0f;
      opacity: 1;
      .BkHeight_conent_header {
        margin-top: 30px;
        margin-left: 40px;
        p {
          span:nth-child(1) {
            font-size: 18px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
            line-height: 24px;
            -webkit-background-clip: text;
          }
          span:nth-child(2) {
            font-size: 14px;
            font-family: SF Pro Text-Regular, SF Pro Text;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.55);
            line-height: 22px;
            -webkit-background-clip: text;
            margin: 0 8px 0 20px;
            color: red;
          }
          img {
            width: 24px;
            height: 24px;
            cursor: pointer;
          }
        }
      }
      .BkHeight_conent_Ul {
        margin-left: 40px;
        ul {
          li {
            display: flex;
            height: 62px;
            p:nth-child(1) {
              flex: 0 0 9%;
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #898b8d;
              line-height: 62px;
              -webkit-background-clip: text;
              margin-right: 184px;
            }
            p:nth-child(2) {
              flex: 0 0 60%;
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #898b8d;
              line-height: 62px;
              -webkit-background-clip: text;
            }
          }
          li:nth-child(2) {
            p:nth-child(2) {
              position: relative;
              cursor: default;
            }
          }
        }
      }
    }
    .BlockDetails {
      padding-bottom: 20px;
      .Blocks {
        padding: 20px 20px;
        background: #0b0c0f;
        border-radius: 16px 16px 16px 16px;
        .Block_Top {
          margin-bottom: 24px;
          display: flex;
          span {
            flex: 1;
          }
          span:nth-child(1) {
            font-size: 18px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
            line-height: 24px;
            -webkit-background-clip: text;
          }
        }
        .Block_list {
          .block_list_Top {
            display: flex;
            width: 1120px;
            height: 60px;
            background: #14151a;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;

            li {
              font-size: 16px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #898b8d;
              line-height: 62px;
              -webkit-background-clip: text;
            }
            li:nth-child(1) {
              width: 200px;
              // border: 1px solid red;
              margin-left: 20px;
              margin-right: 50px;
            }
            li:nth-child(2) {
              width: 180px;
              margin-right: 10px;
            }
            li:nth-child(3) {
              width: 240px;
              // margin-right: 20px;

              text-align: center;
            }
            li:nth-child(4) {
              width: 200px;
              //margin-left: 10px;
              text-align: center;
              // border: 1px solid red;
            }
            li:nth-child(5) {
              width: 200px;
              text-align: center;
              // border: 1px solid red;
            }
            // li:nth-child(6) {
            //   width: 180px;
            //   text-align: center;
            // }
          }
        }
        .Block_List_center {
          ul {
            min-height: 140px;
            padding: 0 20px;
            li:last-child{
              border-bottom: none;
            }
            li {
              display: flex;
              height: 62px;
              border-bottom: 1px solid #22252e;
              line-height: 62px;
              p {
                font-size: 12px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #ffffff;
                -webkit-background-clip: text;
                img{
                  width: 18px;
                  height: 18px;
                  border-radius: 50%;
                }
              }
            }
            li:last-child {
             border: none;
            }
            p:nth-child(1) {
              width: 200px;
              margin-right: 50px;
              color: #fff;
              cursor: pointer;
            }
            p:nth-child(2) {
              width: 180px;
              margin-right: 20px;
              color: rgba(255, 255, 255, 0.9);
           
              cursor: pointer;
              img{
                margin-top: 20px;
                margin-right: 6px;
              }
            }
           
            p:nth-child(3) {
              width: 240px;
              
              color: #898B8D;
              text-align: center;
            }
            p:nth-child(4) {
              width: 200px;
              text-align: center;
              color: #898B8D;
              // margin-left: 40px;
              // border: 1px solid red;
              text-align: center;
            }
             p:nth-child(5) {
              width: 200px;
              
              // border: 1px solid red;
              text-align: center;
              color: #898B8D;
              text-align: center;
            }
          }
        }
        .Block_List_Bottom {
          margin-top: 20px;
        }
      }
    }
  }
}
.el-pagination {
  display: flex;
  justify-content: right;
  ::v-deep button {
    min-width: 24px !important;
    height: 24px !important;
    font-size: 12px;
    color:#fff !important;
    background: none !important;
    // background: #3c485c !important;
    border-radius: 4px 4px 4px 4px !important;
  }
  ::v-deep ul {
    li {
      min-width: 24px !important;
      height: 24px !important;
      background: none !important;
      //border-radius: 4px 4px 4px 4px !important;
      font-size: 12px;
      font-family: aaa;
      font-weight: 400 !important;
      color: #ffffff !important;
      line-height: 20px !important;
      margin: 0 4px !important;
      padding: 2px 8px !important;
    }
    .active {
      background: #22252E !important;
    }
    .more::before {
      line-height: 20px !important;
    }
  }
}
</style>
